module.exports = function (formName) {
    if (formName.indexOf('.') > 0) {
        const fields = formName.split('.');
        return fields.length > 1 ? fields[fields.length - 1] : fields[0];
    }
    return formName;
};



// WEBPACK FOOTER //
// ./src/analytics/helpers/form-name-parser.js